import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';

const baseUrl = (path: string) =>
  `${serviceUrls.WEB_ONCOLENS.BASE()}/admin/v2?path=${encodeURIComponent(path)}`;

export const LegacyAdminRoutes = {
  // Legacy hospital edit
  hospital: {
    edit: (id: string | number) => baseUrl(`/managehospitals/add/${id}`),
  },
};
